/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Grower_CoordinatesInputs */

const vi_grower_coordinates = /** @type {(inputs: Grower_CoordinatesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Toạ độ`)
};

/**

* @param {Grower_CoordinatesInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const grower_coordinates = /** @type {((inputs?: Grower_CoordinatesInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Grower_CoordinatesInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_grower_coordinates(inputs)
});